import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '../material/material.module';
import {ROUTES} from './protected.routes';
import {RouterModule} from '@angular/router';
import {AirlineModule} from '../airline/airline.module';
import {AirportModule} from '../airport/airport.module';
import {ContractModule} from '../contract/contract.module';
import {DashboardModule} from '../dashboard/dashboard.module';
import {FieldsModule} from '../fields/fields.module';
import {LayoutModule} from '../layout/layout.module';
import {FormBuilderModule} from '../form-builder/form-builder.module';
import {ReportModule} from '../report/report.module';
import {UserModule} from '../user/user.module';
import {FormRendererModule} from '../form-renderer/form-renderer.module';
import {ServiceReportModule} from '../servicereport/servicereport.module';
import {GlobalServiceScheduleModule} from '../global-service-schedule/global-service-schedule.module';
import {CerfModule} from '../cerf/cerf.module';
import {BillingReportModule} from '../billing-report/billing-report.module';

/**
 * This is the module that holds all of the protected components of the application.
 * Protected meaning the application has to be logged in to access this module.
 */
@NgModule({
  imports: [
    // angular imports
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    // routes
    RouterModule.forChild(ROUTES),

    // project modules
    DashboardModule,
    AirlineModule,
    AirportModule,
    ContractModule,
    FieldsModule,
    LayoutModule,
    FormBuilderModule,
    FormRendererModule,
    ReportModule,
    UserModule,
    ServiceReportModule,
    GlobalServiceScheduleModule,
    CerfModule,
    BillingReportModule
  ],
  entryComponents: [

  ],
  declarations: [
  ],
  providers: [
  ],
  exports: [

  ]
})
export class ProtectedModule {
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/protected/protected.module.ts